import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_DOWNLOAD_CLOUD: GlameraIconDefinition = {
  name: 'download-cloud',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-download-cloud-arrow">
      <path d="M12 13v8l-4-4"></path>
      <path d="m12 21 4-4"></path>
    </g>
    <path class="glm-download-cloud-shape" d="M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-download-cloud-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './download-cloud.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DownloadCloudIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_DOWNLOAD_CLOUD;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
